"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentContext = void 0;
var react_hooks_1 = require("@apollo/react-hooks");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_router_dom_1 = require("react-router-dom");
var inline_loader_1 = __importDefault(require("../../account-v3/components/inline_loader"));
var app_1 = __importDefault(require("../../cart/app"));
var app_2 = require("../app");
var address_display_1 = __importDefault(require("../components/address_display"));
var billing_address_1 = __importDefault(require("../components/billing_address"));
var braintree_fields_1 = __importDefault(require("../components/braintree_fields"));
var discount_code_field_1 = __importDefault(require("../components/discount_code_field"));
var paypal_1 = __importDefault(require("../components/paypal"));
var shipping_method_1 = __importDefault(require("../components/shipping_method"));
var stripe_fields_1 = __importDefault(require("../components/stripe_fields"));
var subtotals_1 = __importDefault(require("../components/subtotals"));
var mutation_process_checkout_1 = require("../graphql/mutation_process_checkout");
var query_get_shipping_rates_1 = require("../graphql/query_get_shipping_rates");
var useContext = react_1.default.useContext, useState = react_1.default.useState, useRef = react_1.default.useRef;
var CHECKOUT_TOKEN_LOCALSTORAGE_KEY = 'rechargeCheckoutToken';
exports.PaymentContext = (0, react_1.createContext)(null);
exports.default = (function () {
    var _a;
    var context = useContext(app_2.CheckoutContext);
    if (!context)
        return null;
    var history = (0, react_router_dom_1.useHistory)();
    var handlePaymentErrors = function (err) {
        var e_1, _a;
        if (err.networkError) {
            dataLayerPushEvent('checkout__paymentError', { paymentErrorType: 'NETWORK_ERROR' });
            setPaymentError(getPaymentErrorMessage('NETWORK_ERROR'));
            return;
        }
        var errType = 'PROCESSING_ERROR';
        if (err.graphQLErrors) {
            try {
                for (var _b = __values(err.graphQLErrors), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var gqlError = _c.value;
                    if (['CHECKOUT_ALREADY_PROCESSED', 'INSUFFICIENT_INVENTORY', 'CARD_DECLINED', 'CVV_INCORRECT'].includes(gqlError.message))
                        errType = gqlError.message;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        setPaymentError(getPaymentErrorMessage(errType));
        dataLayerPushEvent('checkout__paymentError', { paymentErrorType: errType });
        console.error('handlepaymenterrors', err.graphQLErrors);
    };
    var _b = __read((0, react_hooks_1.useMutation)(mutation_process_checkout_1.PROCESS_CHECKOUT, { onError: handlePaymentErrors }), 2), processCheckoutMutation = _b[0], processCheckoutError = _b[1].error;
    var paymentProvider = context.paymentProvider, imageUrls = context.imageUrls, setBillingAddress = context.setBillingAddress, billingAddress = context.billingAddress, cart = context.cart, isPaypalEnabled = context.isPaypalEnabled, rechargeCheckoutToken = context.rechargeCheckoutToken, textStrings = context.textStrings, setCheckoutComplete = context.setCheckoutComplete, dataLayerPushEvent = context.dataLayerPushEvent, setChargeId = context.setChargeId, setPaymentMethod = context.setPaymentMethod, isPaymentValid = context.isPaymentValid, paymentMethod = context.paymentMethod, paymentInfo = context.paymentInfo, setPaymentInfo = context.setPaymentInfo, checkoutComplete = context.checkoutComplete, shippingAddress = context.shippingAddress;
    var _c = __read((0, react_hooks_1.useLazyQuery)(query_get_shipping_rates_1.GET_CHECKOUT_SHIPPING_RATES), 2), getShippingRates = _c[0], _d = _c[1], loadingRates = _d.loading, shippingRateData = _d.data;
    var containsSubscription = (0, react_1.useMemo)(function () { return cart.lineItems.some(function (li) { return li.properties && !!li.properties.subscription_id; }); }, []);
    var _e = __read(useState(false), 2), isProcessing = _e[0], setProcessingFlag = _e[1];
    var _f = __read(useState(false), 2), showFormErrors = _f[0], setFormErrorsVisibility = _f[1];
    var _g = __read(useState(false), 2), newBillingAddress = _g[0], setNewBillingAddress = _g[1];
    var _h = __read(useState(), 2), cardType = _h[0], setCardType = _h[1];
    var newBillingForm = (0, react_hook_form_1.useForm)({ defaultValues: {}, mode: 'onBlur' });
    var _j = __read(useState(), 2), paymentError = _j[0], setPaymentError = _j[1];
    var _k = __read(useState(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            ;
            (function () { return function (addr) {
                throw new Error('tokenizer needs to be implemented');
            }; })();
            return [2 /*return*/];
        });
    }); }), 2), ccTokenizer = _k[0], setCCTokenizer = _k[1];
    var checkboxRef = useRef(null);
    var isBillingValid = newBillingAddress ? newBillingForm.formState.isValid : true;
    (0, react_1.useEffect)(function () {
        if (checkoutComplete) {
            history.push('/confirmation');
            return;
        }
        if (rechargeCheckoutToken)
            getShippingRates({ variables: { token: rechargeCheckoutToken } });
    }, [rechargeCheckoutToken]);
    var completeCheckout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isBillingValid || !isPaymentValid) {
                        setFormErrorsVisibility(true);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    setProcessingFlag(true);
                    if (!newBillingAddress) return [3 /*break*/, 3];
                    return [4 /*yield*/, setBillingAddress(newBillingForm.getValues())];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, processPayment()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 7];
                case 6:
                    setProcessingFlag(false);
                    setFormErrorsVisibility(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var processPayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newPaymentInfo, _a, mutationVars, result, error_2;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 7, 8, 9]);
                    if (!(paymentMethod === 'paypal')) return [3 /*break*/, 1];
                    _a = paymentInfo;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, ccTokenizer(billingAddress)];
                case 2:
                    _a = _d.sent();
                    _d.label = 3;
                case 3:
                    newPaymentInfo = _a;
                    console.debug('*** tokenized Info', newPaymentInfo);
                    if (!newPaymentInfo) {
                        dataLayerPushEvent('checkout__tokenizationError', { numLineItems: cart.lineItems.length });
                        setPaymentError('PAYMENT_ERROR');
                        return [2 /*return*/];
                    }
                    if (!rechargeCheckoutToken)
                        return [2 /*return*/, null];
                    setPaymentInfo(newPaymentInfo);
                    mutationVars = {
                        token: rechargeCheckoutToken === null || rechargeCheckoutToken === void 0 ? void 0 : rechargeCheckoutToken.toString(),
                        paymentProcessor: paymentProvider,
                        paymentType: paymentMethod === 'creditCard' ? 'CREDIT_CARD' : 'PAYPAL',
                        paymentToken: newPaymentInfo.token,
                        acceptsMarketing: !!((_b = checkboxRef.current) === null || _b === void 0 ? void 0 : _b.checked),
                    };
                    console.debug('*** mutationVars', mutationVars);
                    return [4 /*yield*/, processCheckoutMutation({ variables: mutationVars })];
                case 4:
                    result = _d.sent();
                    console.debug('*** result', result);
                    if (!(result && ((_c = result.data) === null || _c === void 0 ? void 0 : _c.processCheckout))) return [3 /*break*/, 6];
                    setCheckoutComplete(true);
                    setChargeId(Number(result.data.processCheckout.charge_id));
                    localStorage.removeItem(CHECKOUT_TOKEN_LOCALSTORAGE_KEY);
                    return [4 /*yield*/, clearCart()];
                case 5:
                    _d.sent();
                    history.push('/confirmation');
                    _d.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_2 = _d.sent();
                    console.error('payment error gets triggered here', error_2);
                    dataLayerPushEvent('checkout__paymentError', {});
                    handlePaymentErrors(error_2);
                    return [3 /*break*/, 9];
                case 8:
                    setTimeout(function () { return setPaymentError(undefined); }, 20000);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var getPaymentErrorMessage = function (code) {
        switch (code) {
            case 'ALREADY_PROCESSED':
                localStorage.removeItem(CHECKOUT_TOKEN_LOCALSTORAGE_KEY);
                clearCart();
                return "Your order has already been processed. Please check your email for confirmation. If you don't receive it shortly, please contact customer service.";
            case 'NETWORK_ERROR':
                return 'There was an issue contacting our server. Please try again.';
            case 'INSUFFICIENT_INVENTORY':
                return 'We do not have enough stock of one of the items in your cart. Please remove that item and try again';
            case 'CVV_INCORRECT':
                return 'You entered an incorrect card security code (CVV). Please confirm your credit card information or enter another credit card.';
            case 'CARD_DECLINED':
                return 'Your card was declined. Please confirm your credit card information or enter another credit card.';
            default:
                return 'There was an error processing your payment. Please confirm your credit card information or enter another credit card.';
        }
    };
    var clearCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch('/cart/clear.js', {
                        method: 'POST',
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var setPaymentMethodFromEvent = function (changeEvent) {
        if (changeEvent.target.value === 'creditCard')
            setPaymentMethod('creditCard');
        else if (changeEvent.target.value === 'paypal')
            setPaymentMethod('paypal');
    };
    var submissionErrors = [];
    if (!isPaymentValid)
        submissionErrors.push('payment information');
    if (!isBillingValid)
        submissionErrors.push('billing address');
    var isCardTypeSelected = function (type) {
        return !!cardType && cardType !== type;
    };
    var defaultPaymentContextValue = {
        setPaymentMethodFromEvent: setPaymentMethodFromEvent,
        setCCTokenizer: setCCTokenizer,
        setCardType: setCardType,
    };
    return (react_1.default.createElement(exports.PaymentContext.Provider, { value: defaultPaymentContextValue },
        (!rechargeCheckoutToken || loadingRates || !shippingRateData) && (react_1.default.createElement("div", { className: 'padding-bottom-25' },
            react_1.default.createElement("div", { className: 'padding-4 text-center' },
                react_1.default.createElement(inline_loader_1.default, { isLoading: true, loadingText: 'Please Wait...' })))),
        !!shippingRateData && (react_1.default.createElement("div", null,
            ((_a = shippingRateData === null || shippingRateData === void 0 ? void 0 : shippingRateData.checkoutShippingRates) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(shipping_method_1.default, { shippingRates: shippingRateData.checkoutShippingRates }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("h4", { className: 'h4 margin-bottom-2' }, "Payment Method"),
                react_1.default.createElement("p", { className: 'font-lighter text-brown-grey', style: { fontSize: '14px' } }, "All transactions are secure and encrypted.")),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'checkout-payments-container' },
                    react_1.default.createElement("div", { className: 'checkout-payment' },
                        react_1.default.createElement("div", { className: ' grid-x padding-left-4 padding-4' },
                            react_1.default.createElement("div", { className: 'cell small-2 medium-1' },
                                react_1.default.createElement("input", { type: 'radio', checked: paymentMethod === 'creditCard', id: 'payment-method-cc', value: 'creditCard', onChange: setPaymentMethodFromEvent })),
                            react_1.default.createElement("div", { className: 'cell small-10' },
                                react_1.default.createElement("h5", { className: 'font-lighter' },
                                    react_1.default.createElement("label", { htmlFor: 'payment-method-cc' }, "Credit Card")),
                                react_1.default.createElement("div", { className: 'payment-methods-icons' },
                                    react_1.default.createElement("img", { className: (0, classnames_1.default)({ 'payment-method-icon': true, 'not-selected': isCardTypeSelected('masterCard') }), src: imageUrls.masterCard }),
                                    react_1.default.createElement("img", { className: (0, classnames_1.default)({ 'payment-method-icon': true, 'not-selected': isCardTypeSelected('discover') }), src: imageUrls.discover }),
                                    react_1.default.createElement("img", { className: (0, classnames_1.default)({ 'payment-method-icon': true, 'not-selected': isCardTypeSelected('visa') }), src: imageUrls.visa }),
                                    react_1.default.createElement("img", { className: (0, classnames_1.default)({ 'payment-method-icon': true, 'not-selected': isCardTypeSelected('amex') }), src: imageUrls.amex })))),
                        react_1.default.createElement("div", { className: (0, classnames_1.default)({ 'animated-container bg-almost-white': true, 'closed-immediately': paymentMethod !== 'creditCard' }) },
                            react_1.default.createElement("div", { className: 'horizontal-divider-very-light-pink' }),
                            react_1.default.createElement("div", { className: 'padding-4' },
                                paymentProvider === 'braintree' && react_1.default.createElement(braintree_fields_1.default, null),
                                paymentProvider === 'stripe' && react_1.default.createElement(stripe_fields_1.default, null)))),
                    isPaypalEnabled && (react_1.default.createElement("div", { className: 'checkout-payment' },
                        react_1.default.createElement(paypal_1.default, null)))),
                paymentMethod === 'paypal' && shippingAddress && (react_1.default.createElement("div", null,
                    react_1.default.createElement("h4", { className: 'h4 margin-bottom-2 margin-top-2' }, "Shipping Address"),
                    react_1.default.createElement("div", { className: 'font-lighter padding-right-1  padding-left-2', style: { fontSize: '14px' } },
                        react_1.default.createElement(address_display_1.default, { address: shippingAddress, showCountry: false }),
                        react_1.default.createElement(react_router_dom_1.Link, { to: '/', className: 'text-soft-purple font-size-smaller font-lighter' }, "Edit")))),
                react_1.default.createElement(discount_code_field_1.default, null),
                react_1.default.createElement(billing_address_1.default, { newBillingForm: newBillingForm, newBillingAddress: newBillingAddress, setNewBillingAddress: setNewBillingAddress }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("input", { type: 'checkbox', id: 'accepts_marketing', name: 'acceptsMarketing', style: { transform: 'scale(1.4)' }, ref: checkboxRef, defaultChecked: context.defaultMarketingFlag }),
                    react_1.default.createElement("label", { htmlFor: 'accepts_marketing', className: 'font-lighter' }, "Subscribe to our newsletter")),
                react_1.default.createElement("div", { className: 'checkout-cta-container' },
                    react_1.default.createElement("div", { className: "checkout-disclaimers font-size-small font-gray font-lighter margin-bottom-2 ".concat(isPaymentValid && isBillingValid && 'animated'), dangerouslySetInnerHTML: { __html: containsSubscription ? textStrings.subscriptionDisclaimer : textStrings.regularDisclaimer } }),
                    react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), onClick: completeCheckout, disabled: isProcessing },
                        isProcessing && react_1.default.createElement("img", { style: { width: '1em', height: '1em', marginRight: '1em' }, src: imageUrls.spinner }),
                        "Place Order"),
                    showFormErrors && (!isPaymentValid || !isBillingValid) && (react_1.default.createElement("div", { className: 'margin-top-1' },
                        react_1.default.createElement("div", { className: 'form-error-message' },
                            "There is an error with ",
                            submissionErrors.join(' and '),
                            ". Please fix before placing your order.")))),
                react_1.default.createElement("div", { className: 'margin-top-8 padding-4 bg-almost-white padding-bottom-4 hide-for-medium', style: { marginLeft: '-16px', marginRight: '-16px' } },
                    react_1.default.createElement("h4", { className: 'h4 margin-bottom-2 margin-top-2' }, "Order Details"),
                    react_1.default.createElement(app_1.default, { embedded: true, expanded: true }),
                    react_1.default.createElement(subtotals_1.default, null)),
                paymentError && react_1.default.createElement("div", { className: 'checkout-payment-errors' }, paymentError),
                react_1.default.createElement("div", { className: 'checkout-cta-container hide-for-medium' },
                    react_1.default.createElement("div", { className: "checkout-disclaimers font-size-small font-gray font-lighter margin-bottom-2 ".concat(isPaymentValid && isBillingValid && 'animated'), dangerouslySetInnerHTML: { __html: containsSubscription ? textStrings.subscriptionDisclaimer : textStrings.regularDisclaimer } }),
                    react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), onClick: completeCheckout, disabled: isProcessing },
                        isProcessing && react_1.default.createElement("img", { style: { width: '1em', height: '1em', marginRight: '1em' }, src: imageUrls.spinner }),
                        "Place Order"),
                    showFormErrors && (!isPaymentValid || !isBillingValid) && (react_1.default.createElement("div", { className: 'margin-top-1' },
                        react_1.default.createElement("div", { className: 'form-error-message' },
                            "There is an error with ",
                            submissionErrors.join(' and '),
                            ". Please fix before placing your order.")))))))));
});
